import { connect } from 'react-redux';
import { getName, getIllustration, getAltText, getNotes } from '../selectors';
import { getSummaryFieldValues, getOptionThumbnails } from '../selectors/hybrid';
import WoodBeamSummary from '../components/WoodBeamSummary';

const mapStateToProps = (state, ownProps) => {
  const configuratorState = state.ConfiguratorStore;
  return {
    name: getName(configuratorState),
    illustration: getIllustration(configuratorState),
    imageAltText: getAltText(configuratorState),
    summaryValues: getSummaryFieldValues(configuratorState),
    thumbnails: getOptionThumbnails(configuratorState),
    notes: getNotes(configuratorState)
  };
};

const WoodBeamSummaryContainer = connect(
  mapStateToProps
)(WoodBeamSummary);

export default WoodBeamSummaryContainer;
